import { useRef } from "react";
import classNames from "classnames";
import { useTranslation } from "react-i18next";
import { Grid } from "@/shared/components/Grid";
import { Callout } from "@/shared/ui/ancestry";
import styles from "./AddTimespanPanel.module.scss";

interface AddTimespanPanelProps {
    onItemAdded: () => void;
    disabled: boolean;
    label: string;
    usageHelpText: string;
}

export const AddTimespanPanel = ({ onItemAdded, disabled, label, usageHelpText }: AddTimespanPanelProps) => {
    const { t } = useTranslation();
    const infoTriggerRef = useRef<HTMLButtonElement>(null);

    return (
        <Grid.Container>
            <Grid.Field spanMobile={12} spanTablet={12} spanDesktop={12}>
                <ul aria-label={t("timespan.addDateRange")} className={styles.container}>
                    <li aria-hidden="true" className={styles.label}>
                        {t("timespan.addDateRange")}
                    </li>

                    <li className={styles.content}>
                        <button
                            type="button"
                            className={classNames("link", styles.addTimespanLink)}
                            onClick={onItemAdded}
                            disabled={disabled}
                        >
                            {label}
                        </button>

                        <button
                            type="button"
                            ref={infoTriggerRef}
                            className={classNames("link calloutTooltip icon iconInfo", styles.timespanInfo)}
                            aria-label={t("timespan.infoAriaLabel")}
                        />

                        <span className={classNames("badge badgeColor1", styles.newBadge)}>
                            {t("timespan.newBadge")}
                        </span>
                    </li>
                </ul>
                <Callout trigger={infoTriggerRef} type="hover" position="top" width={240}>
                    {usageHelpText}
                </Callout>
            </Grid.Field>
        </Grid.Container>
    );
};
